import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";

export default function InfoBox(props) {
  const classes = styles();
  const { title, value, main, hasBorder } = props;

  return (
    <Box
      borderLeft={hasBorder ? 1 : 0}
      borderRight={hasBorder ? 1 : 0}
      className={classes.container}
    >
      <Typography className={classes.header}>{title}</Typography>
      <Typography style={{ fontSize: main ? 22 : 16 }}>{value}</Typography>
    </Box>
  );
}

const styles = makeStyles(theme =>
  createStyles({
    container: {
      flex: 1,
      paddingLeft: 8,
      paddingRight: 8,
      borderColor: theme.palette.grey.main
    },
    header: {
      fontSize: 14,
      color: theme.palette.grey.dark,
      fontWeight: "400"
    }
  })
);
